import React from 'react'
import type { TextProps } from '@vtex/admin-ui'
import { csx, cx } from '@vtex/admin-ui'

export type ComparableValueProps = TextProps

export const ComparableValue = ({
  className = '',
  ...props
}: ComparableValueProps) => (
  <span
    variant="detail"
    className={cx(
      csx({
        fontSize: '0.75rem',
        color: '$gray40',
      }),
      className
    )}
    {...props}
  />
)
